import { memo, useCallback, useMemo } from 'react';

import GuardianEventRow from '@/features/guardian/components/guardian-event-row';
import type { UpcomingWeekItem } from './types';

type UpcomingWeekRowProps = {
  item: UpcomingWeekItem;
  isLast: boolean;
  onPress?: (item: UpcomingWeekItem) => void;
};

function UpcomingWeekRow({ item, isLast, onPress }: UpcomingWeekRowProps) {
  const date = useMemo(() => ({ day: item.day, date: item.date }), [item.date, item.day]);

  const handlePress = useCallback(() => {
    onPress?.(item);
  }, [item, onPress]);

  return (
    <GuardianEventRow
      accentColor={item.accentColor}
      chevronName="IcPaginationArrow"
      date={date}
      playerAvatar={item.playerAvatar}
      playerName={item.playerName}
      showDivider={!isLast}
      title={item.title}
      variant="list"
      onPress={handlePress}
    />
  );
}

export default memo(UpcomingWeekRow);
